import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import createToolPod from "src/infra/createToolPod";
import icon from "./assets/logo.svg";
import { Question } from "./types";

export const appMetadataPairshare = () => ({
  href: "pairshare",
  title: autoTranslate("Think Pair Share"),
  backgroundColor: "dt_content_accent" as const,
  icon,
  closeButtonStyle: { color: "dt_content_primary" as const },
  textColor: "#000000",
  titleColor: "dt_content_light",
});

const STATE_KEY = "pairshare";
export const { install, action: RECEIVE_QUESTION } = createToolPod(STATE_KEY, "RECEIVE_QUESTION");
export default install;

export type PairShareState = {
  question: Question;
};

export type PairShareSlice = {
  [STATE_KEY]: PairShareState;
};
